import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e044f9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col eFj-content-subheader" })
], -1))
const _hoisted_3 = { class: "row eFj-headline" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "row g-0 eFj-login-content" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "input-group has-feedback py-5" }
const _hoisted_11 = { class: "login__container--password" }
const _hoisted_12 = ["type", "placeholder"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "btn action__button_primary eFj-login-button" }
const _hoisted_15 = { class: "row eFj-login-link-section" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString($setup.componentResource.efjTitel), 1),
          _hoisted_5
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.tryLogin()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "userName",
              class: "form-control",
              placeholder: $setup.componentResource.benutzerName,
              required: "",
              autocomplete: "current-password",
              spellcheck: "false",
              autocorrect: "off",
              autocapitalize: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.passwordType,
                id: "userPassword",
                class: "form-control rounded-right login__input--password",
                placeholder: $setup.componentResource.password,
                autocomplete: "current-password",
                spellcheck: "false",
                autocorrect: "off",
                autocapitalize: "off",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
              }, null, 8, _hoisted_12), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("img", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.togglePassword && $setup.togglePassword(...args)), ["prevent"])),
                class: "password-image form-control-feedback",
                src: $setup.passwortIcon,
                alt: "Hidden",
                width: "50",
                height: "40"
              }, null, 8, _hoisted_13)
            ])
          ]),
          _createElementVNode("button", _hoisted_14, _toDisplayString($setup.componentResource.login), 1)
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            href: "#",
            class: "nav-link",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.registerUserLink && $setup.registerUserLink(...args)), ["prevent"]))
          }, _toDisplayString($setup.componentResource.registrierungLink), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("a", {
            href: "#",
            class: "nav-link",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.passwordForgotten && $setup.passwordForgotten(...args)), ["prevent"]))
          }, _toDisplayString($setup.componentResource.passwordVergessen), 1)
        ])
      ])
    ])
  ]))
}